import { APP_ONLINE_STATUS } from "./actionTypes";

export function appOnlineStatusReducer(state = { isOnline: navigator.onLine }, action = {}) {
    if (action.type === APP_ONLINE_STATUS) {
        return action.payload;
    }
    return state;
}